import { useState } from 'react'
import styled from 'styled-components/macro'

import { Button, EmptyState, Layout } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import IconLoadsmart from 'core/ui/assets/icon-loadsmart.svg'
import IllustrationDepartingTruck from 'core/ui/assets/illustration-departing-truck.svg'

import { SignUpDialog } from 'auth/ui/SignUpDialog'

const Wrapper = styled(Layout.Stack)`
  width: 100%;
  height: 100%;
  padding: ${getToken('space-3xl')};
`

export function UnauthorizedInviteState() {
  const [dialogOpen, setDialogOpen] = useState(false)

  function handleSignUp() {
    setDialogOpen(true)
  }

  function handleCancelSignUp() {
    setDialogOpen(false)
  }

  function handleCompleteSignUp() {
    setDialogOpen(false)
  }

  return (
    <Wrapper align="center" justify="center">
      <EmptyState
        variant="page"
        illustration={IllustrationDepartingTruck}
        title="This invite link is no longer valid"
        description="This page isn’t available with the link you used. If you were invited to this RFP, ask the shipper to send a fresh invite link."
      />
      <Button
        type="button"
        variant="primary"
        leading={<img src={IconLoadsmart} alt="" />}
        onClick={handleSignUp}
      >
        Sign up to see your invites
      </Button>
      {dialogOpen && (
        <SignUpDialog
          onCancel={handleCancelSignUp}
          onComplete={handleCompleteSignUp}
          context="error-state"
        />
      )}
    </Wrapper>
  )
}
